const AzureSsoCallback = () => null;

export default AzureSsoCallback;
